import React, { useState } from "react";
import { motion } from "framer-motion";
import FooterListTitle from "./FooterListTitle";
import { paymentCard } from "../../../assets/images";
import Image from "../../designLayouts/Image";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"; // Import js-cookie for cookie handling
import styled from "styled-components";
import "./Footer.css";
import { Sunglasses, Eyeglasses, Eye, ShieldCheck,Rulers, Book, Search, PersonSquare } from 'react-bootstrap-icons';




const Footer = () => {
  const navigate = useNavigate();
  const [emailInfo, setEmailInfo] = useState("");
  const [subscription, setSubscription] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const handleProfileClick = () => {
    const accessToken = Cookies.get("accessToken");

    if (accessToken) {
      // If token exists, navigate to Profile
      navigate("/profile");
    } else {
      // If no token, navigate to Sign In
      navigate("/signin");
    }
  };

  const goToOrderHistory = () => {
    navigate("/profile?tab=Order%20History");
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden" id="footer-body">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="mx-auto w-full max-w-screen-xl p-6 py-12 lg:py-16 relative z-10">
        {/* Company Info Section */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Spectsgenie
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg">
            Your trusted partner for premium eyewear solutions. Discover the perfect frames that match your style and vision needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              About Us
              <div className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500"></div>
            </h3>
            <ul className="space-y-3 text-gray-300">
              {[
                { to: "/privacyPolicy", text: "Privacy Policy" },
                { to: "/shippingPolicy", text: "Shipping Policy" },
                { to: "/refundPolicy", text: "Refund Policy" },
                { to: "/disclaimer", text: "Disclaimer" },
                { to: "/legalPolicy", text: "Legal Policy" },
                { to: "/terms-conditions", text: "Terms & Conditions" },
                { to: "/contactUs", text: "Contact Us" }
              ].map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.to} 
                    className="text-gray-300 hover:text-blue-400 transition-all duration-300 hover:translate-x-1 inline-block group"
                  >
                    <span className="relative">
                      {item.text}
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Shop Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              Shop
              <div className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-orange-500 to-yellow-500"></div>
            </h3>
            <ul className="space-y-3 text-gray-300">
              {[
  {
    to: "/prodList",
    state: { message: "Sunglasses", key: "ca_id", value: 2, table: "getallproduct" },
    text: "Sunglasses",
    icon: <Sunglasses size={20} />
  },
  {
    to: "/prodList",
    state: { message: "Eyeglasses", key: "ca_id", value: 10, table: "getallproduct" },
    text: "Eyeglasses",
    icon: <Eyeglasses size={20} />
  },
  {
    to: "/prodList",
    state: { message: "Contact Lenses", key: null, value: null, table: "getalllens" },
    text: "Contact Lenses",
    icon: <Eye size={20} />
  },
  {
    to: "/prodList",
    state: { message: "Genie Blu", key: "ca_id", value: 12, table: "getallproduct" },
    text: "Genie Blu",
    icon: <ShieldCheck size={20} />
  }
].map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.to}
                    state={item.state}
                    className="text-gray-300 hover:text-orange-400 transition-all duration-300 hover:translate-x-1 inline-block group flex items-center gap-2"
                  >
                    <span className="text-lg">{item.icon}</span>
                    <span className="relative">
                      {item.text}
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              Resources
              <div className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-green-500 to-emerald-500"></div>
            </h3>
            <ul className="space-y-3 text-gray-300">
              {[
  { to: "/ipd", text: "How to measure IPD?", icon: <Rulers size={20} /> },
  { to: "/contactLensUsage", text: "Contact Lens Usage", icon: <Book size={20} /> },
  { to: "/eyewearMaterialGuide", text: "Eyewear Material Guide", icon: <Search size={20} /> },
  { to: "/founder", text: "Meet Our Founder", icon: <PersonSquare size={20} /> }
].map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.to}
                    className="text-gray-300 hover:text-green-400 transition-all duration-300 hover:translate-x-1 inline-block group flex items-center gap-2"
                  >
                    <span className="text-lg">{item.icon}</span>
                    <span className="relative">
                      {item.text}
                      <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-green-400 transition-all duration-300 group-hover:w-full"></span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6 relative">
              Connect With Us
              <div className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-purple-500 to-pink-500"></div>
            </h3>
            
            {/* Social Media */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-200">Follow Us</h4>
              <div className="flex space-x-4">
                <a
                  href="https://www.instagram.com/spectsgenieeyewear?igsh=b3NzOXppMGVldDBt"
                  className="group relative"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-pink-500/25">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </div>
                </a>
                <a
                  href="https://www.facebook.com/thelenshopIndia/"
                  className="group relative"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-blue-500/25">
                    <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                    </svg>
                  </div>
                </a>
              </div>
            </div>

            {/* Newsletter Signup */}
          
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-16 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 SpectsGenie. All rights reserved. Made with ❤️ for better vision.
            </p>
          
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;